module.exports = __webpack_public_path__ + "static/media/check-in-finger.cd7ac1ee.png";